// extracted by mini-css-extract-plugin
export default {"dtmfForm":"xIHJT__dtmfForm","formGroup":"kHS0N__formGroup","submitButton":"OKQe6__submitButton","prevCodeContainer":"mj4YU__prevCodeContainer","prevCode":"ocRvx__prevCode"};